import React, { useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Checkbox,
  Text,
  HStack,
  Stack,
  StackSeparator,
} from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../shared/stores/RootStore";
import { toast } from "../../../shared/views/CustomToaster";
import { CustomDialog } from "../../../shared/views/CustomDialog";

const i18prefix = "craway:deleteModal";

interface Props {
  onClose: () => void;
}
const DeleteCraWayModalBase: React.FC<Props> = ({ onClose }) => {
  const { craWayStore } = useStores();
  const craWay = craWayStore.getSelected()!;

  const [submitting, setSubmitting] = useState(false);
  const [allSelected, setAllSelected] = useState(false);

  const submit = async () => {
    setSubmitting(true);

    await craWayStore.deleteCraWay(craWay.id);
    toast("success", t(`${i18prefix}.toast.routeDeleted`));

    setSubmitting(false);
    onClose();
  };

  return (
    <CustomDialog
      onClose={onClose}
      header={t(`${i18prefix}.title`)}
      footer={
        <Button
          loading={submitting}
          disabled={!allSelected}
          colorPalette="red"
          onClick={submit}
        >
          {t(`${i18prefix}.submit`)}
        </Button>
      }
    >
      <Stack separator={<StackSeparator />}>
        <HStack>
          <Checkbox.Root
            colorPalette="red"
            checked={allSelected}
            onCheckedChange={({ checked }) => {
              setAllSelected(!!checked);
            }}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
          </Checkbox.Root>
          <Text>{craWay.name}</Text>
        </HStack>
      </Stack>
    </CustomDialog>
  );
};

export const DeleteCraWayModal = observer(DeleteCraWayModalBase);
